






































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import FormMixin from "@/fit-ui/common/mixins/formMixin";

function isKorean(text) {
  const reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}

// @Component 修饰符注明了此类为一个 Vue 组件
@Component({
  inheritAttrs: false
})
export default class Input extends Mixins(FormMixin) {
  @Prop({ default: false }) public showPassword!: boolean;
  @Prop() public disabled!: boolean;
  @Prop() public readonly!: boolean;
  @Prop({ default: "text" }) public type!: string;
  @Prop({ default: "off" }) public autocomplete!: string;
  @Prop() public size!: string;
  @Prop() public value!: string | number;
  @Prop() public pattern!: RegExp;
  public textareaCalcStyle = {};
  public hovering = false;
  public focused = false;
  public isComposing = false;
  public passwordVisible = false;

  @Watch("value")
  public onValueChange(val) {
    this.notify("change", val);
  }

  get inputDisabled() {
    return this.disabled;
  }

  public handleBlur(event: any) {
    this.focused = false;
    //@ts-ignore 强制触发重绘 避免点击区域失去焦点 iphone6
    document.scrollingElement.scrollTop = document.scrollingElement.scrollTop;
    this.$emit("blur", event);
    this.notify("blur", this.value);
  }

  get nativeInputValue() {
    return this.value === null || this.value === undefined
      ? ""
      : String(this.value);
  }

  @Watch("nativeInputValue")
  public setNativeInputValue() {
    const input = this.getInput();
    if (!input) {
      return;
    }
    if (input.value === this.nativeInputValue) {
      return;
    }
    input.value = this.nativeInputValue;
  }

  public handleFocus(event: TouchEvent) {
    this.focused = true;
    this.$emit("focus", event);
  }

  public handleCompositionStart() {
    this.isComposing = true;
  }

  public handleCompositionEnd(event: any) {
    this.isComposing = false;
    this.handleInput(event);
  }

  public handleCompositionUpdate(event) {
    const text = event.target.value;
    const lastCharacter = text[text.length - 1] || "";
    this.isComposing = !isKorean(lastCharacter);
  }

  public getValue(value: string) {
    if (this.pattern) {
      console.log("pattern", this.value, value, this.pattern.test(value));
      return this.pattern.test(value) ? value : this.value;
    }
    return value;
  }

  public handleInput(event: any) {
    // should not emit input during composition
    // see: https://github.com/ElemeFE/element/issues/10516
    if (this.isComposing) {
      return;
    }
    // hack for https://github.com/ElemeFE/element/issues/8548
    // should remove the following line when we don't support IE
    if (event.target.value === this.nativeInputValue) {
      return;
    }
    this.$emit("input", this.getValue(event.target.value));

    // ensure native input value is controlled
    // see: https://github.com/ElemeFE/element/issues/12850
    this.$nextTick(this.setNativeInputValue);
  }

  public handleChange(event: any) {
    this.$emit("change", event.target.value);
  }

  public clear() {
    this.$emit("input", "");
    this.$emit("change", "");
    this.$emit("clear");
  }

  public handlePasswordVisible() {
    this.passwordVisible = !this.passwordVisible;
    this.focus();
  }

  public getInput(): any {
    return this.$refs.input || this.$refs.textarea;
  }

  public focus() {
    this.getInput().focus();
  }

  public blur() {
    this.getInput().blur();
  }

  public mounted() {
    this.setNativeInputValue();
  }
}
